import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '../../other/breakpoints';
import RowItem from './RowItem';

const Li = styled.li`
  color: white;
  height: calc(15vw * 1.8 + 1.75rem);
  padding-bottom: 1rem;
  margin-top: 0rem;

  &:first-child {
    margin-top: 0;
  }

  & > div {
    position: relative;
    height: 100%;
    width: 100%;
  }

  ${media.mobile} {
    height: calc(40vw * 1.5 + 1.75rem + 1.5rem);
    padding-bottom: 0.75rem;
    margin-top: 2.5rem;
  }
`;

const H3 = styled(Link)`
  font-size: 1.75rem;
  margin-bottom: 1rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
  color: white;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.5s ease;
  display: block;
  position: relative;
  z-index: 2;

  &:focus,
  &:hover {
    color: white;
  }

  ${media.mobile} {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.4rem;
  margin-top: 2.5rem;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-right: 1rem;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

const GroupRow = ({
  category_id,
  name,
  style,
  playlist,
  isSeries,
  existingTmdb,
}) => {
  const scrollRef = useRef(null);
  const isDownRef = useRef(false);
  const startXRef = useRef(0);
  const scrollLeftRef = useRef(0);
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleMouseDown = (e) => {
      isDownRef.current = true;
      hasScrolledRef.current = false;
      startXRef.current = e.pageX - container.offsetLeft;
      scrollLeftRef.current = container.scrollLeft;
      container.style.cursor = 'grabbing';
      container.style.userSelect = 'none';
    };

    const handleMouseLeave = () => {
      isDownRef.current = false;
      container.style.cursor = 'grab';
      container.style.userSelect = '';
    };

    const handleMouseUp = (e) => {
      if (isDownRef.current && hasScrolledRef.current) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      isDownRef.current = false;
      container.style.cursor = 'grab';
      container.style.userSelect = '';
      hasScrolledRef.current = false;
    };

    const handleMouseMove = (e) => {
      if (!isDownRef.current) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startXRef.current) * 2;
      container.scrollLeft = scrollLeftRef.current - walk;
      hasScrolledRef.current = true;
    };

    container.addEventListener('mousedown', handleMouseDown, {
      passive: false,
    });
    container.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseup', handleMouseUp, { capture: true });
    document.addEventListener('mousemove', handleMouseMove, { passive: false });

    return () => {
      container.removeEventListener('mousedown', handleMouseDown);
      container.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseup', handleMouseUp, { capture: true });
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    playlist.length > 0 && (
      <Li style={style} className="parent">
        <H3 to={`/${isSeries ? 'series' : 'movie'}/category/${category_id}/`}>
          {name}
        </H3>
        <RowContainer ref={scrollRef}>
          {playlist.map((x, id) => (
            <RowItem
              id={id}
              key={'vod' + (x.stream_id || x.series_id)}
              name={x.name}
              stream_icon={x.stream_icon || x.cover}
              stream_id={x.stream_id || x.series_id}
              stream_url={x.direct_source}
              category_id={category_id}
              container_extension={x.container_extension}
              last={false}
              isSeries={isSeries}
              existingTmdb={x.tmdb}
            />
          ))}
        </RowContainer>
      </Li>
    )
  );
};

export default GroupRow;
